import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { WhatYouGet } from './components/WhatYouGet';
import { Testimonials } from './components/Testimonials';
import { PriceClose } from './components/PriceClose';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
import { MobileCtaBar } from './components/MobileCtaBar';
export function App() {
  return <div className="w-full bg-cream" data-id="element-0" data-mp="2mm2j470bqezq">
      <UrgencyBar data-id="element-1" data-mp="2mn5f2tci77mi" />
      <main data-id="element-2" data-mp="2mjpuxc3z38e8">
        <Hero data-id="element-3" data-mp="2mjznn7gejtnm" />
        <PainSection data-id="element-4" data-mp="31agnimde2bie" />
        <WhatYouGet data-id="element-5" data-mp="31ayplzmqfjy8" />
        <Testimonials data-id="element-6" data-mp="31bi8bik7icdb" />
        <PriceClose data-id="element-7" data-mp="31ctfztgrw49p" />
        <Faq data-id="element-8" data-mp="2wk0av4he6tx3" />
      </main>
      <Footer data-id="element-9" data-mp="2wjqg73lejyl2" />
      <div className="h-20 md:hidden" aria-hidden="true" data-id="element-10" data-mp="2wj8dpp85co4p" />
      <MobileCtaBar data-id="element-11" data-mp="28u5x8kp911bs" />
    </div>;
}